class OxgIntersectionObserver {
    constructor(name = 'defaultName', autoInit = true) {
        this.name = name;
        this.elements = new Array;
        this.observers = new Array;
        if (autoInit) { this.init() }
    }
    getOptions(element) {
        if (!element) return
        return {
            root: element.getAttribute('data-root') ? document.getElementById(element.getAttribute('data-root')) : null,
            rootMargin: element.getAttribute('data-root-margin') ? element.getAttribute('data-root-margin') : '-100px',
            threshold: element.getAttribute('data-threshold') ? element.getAttribute('data-threshold') : [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        }
    }
    init() {
        //get elements
        let ioElements = document.querySelectorAll('.io-element')
        //define behaviour on scroll update for the observers
        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                let ratio = Math.round(entry.intersectionRatio*10)/10
                entry.target.setAttribute('data-intersection-ratio', ratio)
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-intersecting')
                    entry.target.classList.remove('is-not-intersecting')
                } else {
                    entry.target.classList.add('is-not-intersecting')
                    entry.target.classList.remove('is-intersecting')
                }
            })
        }
        //populate elements array
        ioElements.forEach((element) => {
            let options = this.getOptions(element)
            let elementObject = {
                element: element,
                options: options,
            }
            this.elements.push(elementObject);
        })
        //create observers
        this.elements.forEach((object) => { 
            this.observers.push({observer: new IntersectionObserver(observerCallback, object.options), element: object.element })
        })
        //start observing
        this.observers.forEach((observerObject) => {
            observerObject.observer.observe(observerObject.element)
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const oxgIntersectionObservers = new OxgIntersectionObserver();
});